<form class="flex flex-col gap-6" (submit.prevent)="onSubmit()" autocomplete="off">
  <div class="flex items-center">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.locations.details.general.sectionTitle' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.locations.details.general.sectionSubtitle' | transloco }}
      </p>
    </div>
    <div class="flex-none flex gap-2 items-center">
      @if (!enableEdit()) {
        <ui-button
          mode="outlined"
          class="hidden sm:inline"
          (click)="onClickEnableEdit()"
          [loading]="editButtonLoading()"
          type="button"
        >
          <ng-icon name="heroPencilSquare" size="20" slot="start" class="!block" />
          {{ 'cockpit.locations.details.general.editButton' | transloco }}
        </ui-button>
        <ui-button
          mode="outlined"
          class="sm:hidden"
          [iconOnly]="true"
          [ariaLabel]="'cockpit.locations.details.general.editButton' | transloco"
          (click)="onClickEnableEdit()"
          [loading]="editButtonLoading()"
          type="button"
        >
          <ng-icon name="heroPencilSquare" size="20" class="!block" />
        </ui-button>
      } @else {
        <ui-button type="button" mode="outlined" (click)="onClickCancel()">
          {{ 'cockpit.locations.details.general.cancelButton' | transloco }}
        </ui-button>
        <ui-button
          type="submit"
          [disabled]="!form().touched() || form().invalid()"
          [loading]="isUpdateLoading()"
        >
          <ng-icon name="heroCheck" size="20" slot="start" class="!block" />
          {{ 'cockpit.locations.details.general.saveButton' | transloco }}
        </ui-button>
      }
    </div>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 items-center border-t border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <label
      for="edit-location-name"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.nameLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().name }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-name"
        [formField]="form.name"
      />
      <app-field-errors [fieldState]="form.name()" class="absolute" />
    </div>

    <label
      for="edit-location-zipcode"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.zipCodeLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().address.zipCode }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-zipcode"
        [formField]="form.address.zipCode"
      />
      <app-field-errors [fieldState]="form.address.zipCode()" class="absolute" />
    </div>

    <label
      for="edit-location-city"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.cityLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().address.city }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-city"
        [formField]="form.address.city"
      />
      <app-field-errors [fieldState]="form.address.city()" class="absolute" />
    </div>

    <label
      for="edit-location-street"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.streetLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().address.street }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-street"
        [formField]="form.address.street"
      />
      <app-field-errors [fieldState]="form.address.street()" class="absolute" />
    </div>

    <label
      for="edit-location-streetNumber"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.streetNumberLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().address.streetNumber }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-streetNumber"
        [formField]="form.address.streetNumber"
      />
      <app-field-errors [fieldState]="form.address.streetNumber()" class="absolute" />
    </div>

    <label
      for="edit-location-streetNumberSuffix"
      class="pt-6 sm:py-6 sm:min-h-22 flex items-center mb-[-1px] border-b-none sm:border-b border-surface-highlight dark:border-surface-highlight-darkmode text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-6 line-clamp-2"
    >
      {{ 'cockpit.locations.details.general.streetNumberSuffixLabel' | transloco }}
    </label>
    <div
      class="pb-6 pt-1 sm:py-6 border-b border-surface-highlight dark:border-surface-highlight-darkmode"
    >
      <span
        [class.hidden]="enableEdit()"
        class="min-h-10 flex items-center sm:px-3 sm:py-1.5 text-on-surface-subtle dark:text-on-surface-subtle-darkmode leading-6 line-clamp-1"
      >
        {{ model().address.streetNumberSuffix }}
      </span>
      <ui-input-simple
        [class.hidden]="!enableEdit()"
        inputId="edit-location-streetNumberSuffix"
        [formField]="form.address.streetNumberSuffix"
      />
      <app-field-errors [fieldState]="form.address.streetNumberSuffix()" class="absolute" />
    </div>
  </div>
</form>
